import { User, MapPin, Building2, Phone, UserCheck } from "lucide-react";

const FIELDS = [
  { key: "name", label: "Customer Name", icon: User, placeholder: "Full name" },
  { key: "location", label: "Location / Area", icon: MapPin, placeholder: "e.g. Koramangala" },
  { key: "city", label: "City", icon: Building2, placeholder: "e.g. Bangalore" },
  { key: "mobile", label: "Mobile Number", icon: Phone, placeholder: "10-digit mobile", inputMode: "numeric" },
  { key: "quotation_given_by", label: "Quotation Given By", icon: UserCheck, placeholder: "Sales executive name" },
];

export default function Step1Customer({ data, onChange }) {
  return (
    <div className="space-y-4" data-testid="step-1-customer">
      <div className="mb-6">
        <div className="overline text-[#C5A880] mb-2">Step 01</div>
        <h1 className="text-3xl sm:text-4xl font-display font-bold leading-tight">
          Customer details
        </h1>
        <p className="text-white/50 mt-2 text-sm">
          Capture essentials. We keep it minimal — just what&apos;s needed.
        </p>
      </div>

      <div className="card-luxe space-y-5">
        {FIELDS.map((f) => {
          const Icon = f.icon;
          return (
            <div key={f.key}>
              <label className="label-luxe flex items-center gap-2">
                <Icon size={12} className="text-[#C5A880]/80" />
                {f.label}
              </label>
              <input
                className="input-luxe"
                placeholder={f.placeholder}
                inputMode={f.inputMode}
                value={data[f.key] || ""}
                onChange={(e) => onChange({ ...data, [f.key]: e.target.value })}
                data-testid={`customer-${f.key}-input`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
